export { default as TableAggregationWidget } from "./table_aggregation_widget";
export { default as WidgetEditTableAggregation } from "./table_aggregation_widget_form";

import * as TableAggregationWidgetFactory from "./table_aggregation_widget_factory";

export { TableAggregationWidgetFactory };
